import React from "react";

const NoticeItem = () => {
  return (
    <div className="__sweven_notices-items--item">
      <div className="__sweven_notices-items--item__title">MEGA LOGO OFFER</div>
      <div className="__sweven_notices-items--item__meta">
        <div className="__sweven_notices-items--item__meta_person">
          Sweven incorporate family
        </div>
        <div className="__sweven_notices-items--item__meta_date">
          2019-12-17
        </div>
      </div>
      <div className="__sweven_notices-items--item__body">
        We Sweven Incorporate Private Limited family is always focusing on
        satisfaction of valuable customers from the beginning establishment.
        After company formation we are working on every sector for yours ease
        with "Ink with Digital" moto. So, we are heartily announcing for all of
        you that we are making an offer for a limited period on logo design
        which are mentioned in the document.
      </div>
      <div className="__sweven_notices-items--item__link">
        Click here to view full information
      </div>
    </div>
  );
};

export default NoticeItem;
